
/**
 * List of substrings that indicate an image URL should be ignored.
 * Only plain strings are allowed.
 */
const ignoredImageStrings: string[] = [

    'io_noimage'
]

/**
 * Check if a given image URL should be ignored.
 * @param url - The image URL to check.
 * @returns true if the URL includes any ignored string.
 */
export function isIgnoredImageUrl(url: string): boolean {
    return ignoredImageStrings.some(pattern => url.includes(pattern))
}